import React from "react";
import DomainChecker from "./DomainChecker";
import { ArrowRight } from "@phosphor-icons/react";
import { useI18n } from "@/context/LangContext";

export default function Hero() {
  const { t } = useI18n();
  return (
    <section id="top" data-testid="hero" className="relative pt-20 md:pt-32 pb-10 md:pb-20 border-b border-[color:var(--line)]">
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" aria-hidden />
      <div className="container-x relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          <div className="lg:col-span-8">
            <div className="eyebrow mb-4 md:mb-6">{t("hero.eyebrow")}</div>
            <h1 className="font-display font-black leading-[1] tracking-tight text-[42px] sm:text-6xl lg:text-[88px]">
              {t("hero.title.a")} <br className="hidden md:block" />
              {t("hero.title.b")}<span className="text-[color:var(--brand)]">{t("hero.title.c")}</span>.
            </h1>
            <p className="mt-5 md:mt-8 text-base md:text-xl text-neutral-700 max-w-2xl leading-relaxed">
              {t("hero.sub")}
            </p>
            <div className="mt-6 md:mt-10 flex flex-wrap items-center gap-3">
              <a href="#contact" data-testid="hero-cta-primary" className="btn-brand">
                {t("hero.quote")} <ArrowRight weight="bold" size={16} />
              </a>
              <a href="#web" data-testid="hero-cta-secondary" className="btn-ghost">{t("hero.packages")}</a>
            </div>

            <div className="mt-8 md:mt-14 grid grid-cols-3 gap-4 md:gap-6 max-w-xl">
              {[
                { k: "42", vKey: "hero.stat.clients" },
                { k: "9y", vKey: "hero.stat.years" },
                { k: "4", vKey: "hero.stat.hubs" },
              ].map((s) => (
                <div key={s.vKey} data-testid={`hero-stat-${s.vKey.split(".").pop()}`} className="border-l-2 border-[color:var(--brand)] pl-3">
                  <div className="font-display font-black text-3xl md:text-4xl">{s.k}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-neutral-500 mt-1">{t(s.vKey)}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4 mt-4 lg:mt-0">
            <DomainChecker />
          </div>
        </div>
      </div>
    </section>
  );
}
